import React from "react";
import {
  Card,
  Typography,
  Grid,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
} from "@mui/material";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FormFileInputField from "../../../../Components/form/FormInputFeild";

export default function PaymentDetails({ control }) {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Please note that your appointment will only be{" "}
          <strong style={{ color: "#1b8b7f" }}>
            confirmed once the payment
          </strong>{" "}
          is made to the account provided below.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Card
          variant="outlined"
          sx={{ borderRadius: 2, border: "1px solid #1b8b7f", mb: 1 }}
        >
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    width: { xs: "40%", md: "30%" },
                    borderRight: "1px solid rgba(224, 224, 224, 1)", // 👈 vertical border
                    py: 1.5, // 👈 reduce vertical padding
                  }}
                >
                  Account Title
                </TableCell>
                <TableCell sx={{ py: 1.5 }}>EKKO (Private) Limited</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    py: 1.5, // 👈 reduce vertical padding
                  }}
                >
                  Account Number
                </TableCell>
                <TableCell sx={{ py: 1.5 }}> 22927917560703</TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    py: 1.5, // 👈 reduce vertical padding
                  }}
                >
                  IBAN
                </TableCell>
                <TableCell sx={{ py: 1.5 }}>
                  PK34HABB0022927917560703{" "}
                  <IconButton
                    onClick={() => handleCopy("PK34HABB0022927917560703")}
                    size="small"
                    sx={{ ml: 1 }}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    py: 1.5, // 👈 reduce vertical padding
                  }}
                >
                  Bank & Branch Name
                </TableCell>
                <TableCell sx={{ py: 1.5 }}>
                  HBL NUST Branch, Islamabad
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    fontWeight: 600,
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    py: 1.5, // 👈 reduce vertical padding
                  }}
                >
                  Address
                </TableCell>
                <TableCell sx={{ py: 1.5 }}>
                  EKKO (PRIVATE) LIMITED, 1C4-W, BUILDING 1, NATIONAL SCIENCE &
                  TECHNOLOGY PARK, KHYBER ROAD NUST H-12, Islamabad, Pakistan
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <FormFileInputField
          label="Please upload payment receipt"
          control={control}
          fieldname="paymentReceipt"
          acceptedExtensions={["png", "jpg", "jpeg", "pdf"]} // Include all common image extensions and PDFs
          required={true}
          maxFileSize={32 * 1024 * 1024} // Max file size of 32 MB
        />
      </Grid>
    </Grid>
  );
}
